import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { TextField } from '@td-client-frontend/common';
import { Add } from '@td-client-frontend/icons';
import { ActivitySearchChangeObject, PartialActivityLogSearchQuery } from '../../../@types/Audit';

export interface CheckBoxItem {
  label: string;
  value: string;
  checked: boolean;
  lengthError: string;
  validateFn: (length: number) => boolean;
}

export interface ActivityFilterInput {
  filter: CheckBoxItem;
  searchQuery: PartialActivityLogSearchQuery;
  onChange: (changeObj: ActivitySearchChangeObject) => void;
  onError: (isError: boolean, filterName: string) => void;
  onRemove: (value: string) => void;
}

export const ActivityFilterInput: FC<ActivityFilterInput> = ({ filter, searchQuery, onChange, onError, onRemove }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange({ key: filter.value, value: e.target.value });
  };
  const [isFocused, setIsFocused] = useState<boolean>();
  const inputRef = useRef<HTMLInputElement>(null);
  // @ts-ignore
  const filterValueLength = searchQuery[filter.value]?.length;

  const isError: boolean = useMemo(
    () => !isFocused && !filter.validateFn(filterValueLength),
    [isFocused, filter, filterValueLength]
  );

  const activityFilterInputError: string = useMemo(() => {
    onError(isError, filter.value);
    return isError ? filter.lengthError : '';
  }, [filter.lengthError, filter.value, isError, onError]);

  const onFocus = () => setIsFocused(true);
  const onBlur = () => setIsFocused(false);

  useEffect(() => {
    inputRef?.current?.focus();
  }, []);

  const handleRemove = () => {
    onError(false, filter.value);
    onChange({ key: filter.value, value: '' });
    onRemove(filter.value);
  };
  return (
    <div className="flex">
      <TextField
        name={filter.label}
        onChange={handleChange}
        placeholder={filter.label}
        // @ts-ignore
        value={searchQuery[filter.value] || ''}
        aria-label={filter.label}
        wrapperClasses="flex flex-col w-72 mb-3"
        label={filter.label}
        onFocus={onFocus}
        onBlur={onBlur}
        isError={isError}
        error={activityFilterInputError}
        ref={inputRef}
      />
      <button
        onClick={handleRemove}
        className="flex transform rotate-45 w-6 h-6 mt-5 ml-2 justify-self-center items-center focus:outline-none active:outline-none hover:transform hover:scale-110"
      >
        <Add />
      </button>
    </div>
  );
};

export default ActivityFilterInput;
